import "whatwg-fetch";
import React, { Component } from "react";
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import SearchIcon from "@material-ui/icons/Search";
import PropTypes from "prop-types";

export default class DropdownFilter extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  handleClick = () => {
    this.setState({
      open: true,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  blurDropdownFilter = (filter) => {
    this.props.filter(filter);
  };

  render() {
    let { filterValue, filter, enumDict } = this.props;
    let appliedFilter = Object.keys(filterValue).length;
    return (
      <React.Fragment>
        <div
          ref={(node) => {
            this.node = node;
          }}
          onClick={this.handleClick}
          className="table-filter-button"
        >
          {appliedFilter ? (
            <b>
              <SearchIcon
                style={{
                  verticalAlign: "text-bottom",
                  height: "12px",
                  width: "12px",
                }}
              />{" "}
              Filter Applied
            </b>
          ) : (
            "Click to filter"
          )}
        </div>
        <Popover
          open={this.state.open}
          anchorEl={this.node}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
          targetOrigin={{ horizontal: "left", vertical: "top" }}
          onClose={this.handleRequestClose}
        >
          <List className="table-dropdown">
            {Object.keys(enumDict).map((key, i) => {
              let checked = filterValue[key];
              let value = Object.assign({}, filterValue);
              if (checked) delete value[key];
              else value[key] = true;
              return (
                <ListItem key={"inside" + i}>
                  <Checkbox
                    checked={!!checked}
                    onClick={filter.bind(this, value)}
                  />
                  <ListItemText primary={enumDict[key]} />
                </ListItem>
              );
            })}
          </List>
        </Popover>
      </React.Fragment>
    );
  }

  static propTypes = {
    filterValue: PropTypes.object,
    enumDict: PropTypes.object,
    filter: PropTypes.func,
  };
}
